export default __webpack_public_path__ + "static/media/myFace.40865d01.JPG";